<template>
  <div class="container-fluid">
    <TableControls @searchterm="filterSets($event)" :canSearch="true"/>
    <div class="row">
      <div class="col-md-12">
          <!-- TODO: fix filtering-->
              <BaseTable
              :columns="columns"
              :tableData="sets"
              :pagination="pagination"
              :paginationParams="index"
              :indexCallback="getSets"
            >
              <span slot="name" slot-scope="{ row }">
                <router-link :to="`/sets/edit/${row.uuid}`">{{row.name}}</router-link>
              </span>
              <span slot="edited_by" slot-scope="{ row }">
                {{ row.edited_by_first_name }}, {{ row.edited_by_last_name }}
              </span>
              <span slot="offer" slot-scope="{ row }">
                {{ row.offers.length}}
              </span>
              <span slot="delete" slot-scope="{ row }">
                <i class="fas fa-trash-alt pointer" @click="showDeleteModal(row)"></i>
              </span>
              <span slot="duplicate" slot-scope="{ row }">
                <i class="fas fa-copy pointer" @click="showDuplicateModal(row)"></i>
              </span>
            </BaseTable>
        <Modal v-if="show" @close="showModal = false">
          <h3 slot="header">Set {{ modalInformation.name }}</h3>
          <p slot="body">Are you sure you want to delete this Offer?</p>
          <div slot="footer">
            <button class="greyBtn smBtn mr-1" @click="show = false">Cancel</button>
            <button class="blueBtn smBtn ml-1" @click="deleteSet(modalInformation)">Delete</button>
          </div>
        </Modal>
        <Modal v-if="duplicateModal" @close="showModal = false">
          <h3 slot="header">Duplicate Set</h3>
          <div slot="body">
              <div class="form-group">
              <label for="duplicate">Create a New Set Name</label><small> (Name must be unique)</small>
              <input type="text" class="form-control" id="duplicateSetName" v-model="duplicateName">
            </div>
          </div>
          <div slot="footer">
            <button class="greyBtn smBtn mr-1" @click="duplicateModal = false">Cancel</button>
            <button class="blueBtn smBtn ml-1" @click="duplicateSet">Duplicate</button>
          </div>
        </Modal>
      </div>
    </div>
  </div>
</template>
<script>
import Sets from '@/resources/Sets.js'

export default {
  data () {
    return {
      show: false,
      duplicateModal: false,
      modalInformation: {},
      duplicateName: '',
      clone: {},
      sets: [],
      columns: [
        { name: 'Set Name', key: 'name', class: 'col-md-4' },
        { name: 'Offers', key: 'offer', class: 'col-md-1' },
        { name: 'Date Modified*', key: 'updated_at', class: 'col-md-3', filter: 'date' },
        { name: 'Modified By', key: 'edited_by', class: 'col-md-2 text-center' },
        { name: 'Delete', key: 'delete', class: 'col-md-1 text-center' },
        { name: 'Duplicate', key: 'duplicate', class: 'col-md-1 text-center' }
      ],
      index: {
        limit: 10,
        page: 1,
        total: null
      },
      pagination: {}
    }
  },
  mounted () {
    this.getSets()
  },
  methods: {
    getSets () {
      Sets.index(this.index).then(res => {
        this.pagination = res
        this.sets = res.data
      })
    },
    deleteSet (set) {
      const id = set.uuid
      Sets.destroy(id).then(res => {
        this.show = false
        this.$toast('Set succesfully deleted')
        this.getSets()
      })
    },
    duplicateSet () {
      let itemsToDeletecBeforeBeingCloned = ['created_at', 'deleted_at', 'uuid', 'updated_at', 'edited_by', 'offers']
      let offerUuids = []
      let toBeCloned = this.clone
      for (let index = 0; index < toBeCloned.offers.length; index++) {
        offerUuids.push({ offer_uuid: toBeCloned.offers[index].uuid, order: toBeCloned.offers[index].pivot.order, name: toBeCloned.offers[index].name })
      }
      itemsToDeletecBeforeBeingCloned.forEach(e => delete toBeCloned[e])
      toBeCloned['offer_uuids'] = offerUuids
      toBeCloned['name'] = this.duplicateName
      Sets.create(toBeCloned).then(() => {
        this.duplicateModal = false
        this.$toast('Set succesfully cloned')
        this.getSets()
        this.duplicateName = ''
      })
    },
    showDeleteModal (set) {
      this.modalInformation = set
      this.show = true
    },
    showDuplicateModal (set) {
      this.clone = set
      this.duplicateModal = true
    },
    filterSets (term) {
      console.log(term)
      Sets.filter(term).then(res => {
        if (res.error) {
          this.getSets()
        } else {
          this.pagination = res
          this.sets = res.data
        }
      })
    }
  },
  computed: {},
  components: {}
}
</script>
<style lang="scss" scoped>
</style>
